module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"welcomeBack":"Welcome back","forgottenPassword":"Forgot your password?","changeCredentials":"Change credentials","rememberMe":"Remember me","notYou":"Not you?"}}')
  delete Component.options._Ctor
}
